import { Component } from '@angular/core';

@Component({
  selector: 'app-insights',
  standalone: true,
  imports: [],
  templateUrl: './insights.html',
  styleUrl: './insights.css'
})
export class InsightsComponent {
  topRegions = [
    { name: 'North America', value: '45%', amount: '2.4M', color: 'bg-blue-500' },
    { name: 'EMEA', value: '30%', amount: '1.6M', color: 'bg-[#506ef7]' },
    { name: 'APAC', value: '25%', amount: '1.3M', color: 'bg-indigo-400' }
  ];
}
